/*import './css/SecondaryNavBar.css'*/

const SecondaryNavBar = () => {

   
    const handleClick = () => {
        window.open('https://api.whatsapp.com/send?phone=573202028218&text=buen%20día,%20quisiera%20más%20información', '_blank')
    }

    return (
        <>
            <div className="secondary-navbar">
                <div className='secondary-navbar-selector'>
                    <div className="secondary-navbar-box-1">
                        <p>SERVICE CJ PERFORMANCE</p>
                    </div>
                    <div className="secondary-navbar-box-mobile-1">
                        <p>CJ PERFORMANCE</p>
                    </div>
                    <div className="navbar-header">

                        <div className="secondary-navbar-box-2">

                            <button className='now-button' onClick={handleClick}>COTIZAR</button>

                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default SecondaryNavBar